<template>
<v-container style="margin-top:60px;margin-bottom:60px;"  fluid>
  <!-- <v-img src="img/flash.png" style="position:absolute;top:-0px;left:0;right:0; margin:auto;z-index:1000;width:99%;"></v-img> -->
  <!-- <v-card class="rounded-lg" elevation="10" style="position:absolute;top:-0px;left:0;right:0; margin:auto;z-index:1000;width:99%;">
    <v-card-title><center><v-img src="img/flash.png" style="position:absolute;top:-0px;left:0;right:0; margin:auto;z-index:1000;width:99%;"></v-img></center></v-card-title>
  </v-card> -->
<div id="containeri1">
  <v-row>
        <v-col   cols="12" style="display: flex;    flex-direction: column;    align-items: center;    align-self: center;">
          <center><v-img src="img/robo_head_big.png" style="max-width: 106px;"></v-img></center></v-col>
       
  </v-row>

  <v-row>
        <v-col   cols="12" style="display: flex;    flex-direction: row;    align-items: center;    align-self: center;justify-content: center;">
          <span style="font-size:50px;">{{ points }}</span><br>
            <v-img src="img/ico_points.png" style="max-width: 51px;margin-left: 10px;"></v-img>
          </v-col>
       
  </v-row>
</div>


 
<!-- завдання -->
  <v-row justify="center" no-gutters style="    margin-top: 40px;    margin-bottom: 15px;" id="task_block">
    <v-col   cols="12" >
      <v-card style="width: 100%;border-radius: 20px; min-height: 275px;" class="transparent_to_background">
        <div style="padding: 15px;margin-top: -10px;margin-bottom: 0px;">
        <span style="padding: 15px;margin-top: 10px;" class="header_task">Завдання</span>
      </div>
        <div class="carousel-wrapper">
          <div class="carousel" ref="slick">
            <!-- <div v-for="(item, i) in items" :key="i" class="carousel-item"> -->
            <div v-for="(card, i) in cards" :key="i" class="carousel-item">
               <v-card class="brand_card" style="min-width: 205px;max-width: 290px; min-height: 170px;display: flex; margin-bottom: 5px;"
               @click.native="
                     $router.push({
                     name: links[card['data']['type']],
                     params: { routeparam: card.id },
                     })
                  "> 
                  <v-row style="display: flex;    align-content: center;">
                    <v-col cols="8" style="text-align: center;">
                      <span >
                
                    {{ card["data"]["header"] }}<br>({{card['start_date']}}-{{card['end_date']}})
                    </span>
                    </v-col>
                    <v-col cols="4" style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                      <div style="margin-bottom: 10px;position: relative;">
                          <v-img eager  v-if="card['data']['type'].includes('photo')&&!card['data']['type'].includes('dmx')" src="/img/tico_photo.png" alt="Slide Image" style="max-width: 65px;margin-left: -9px"></v-img>
                          <v-img eager  v-if="card['data']['type'].includes('test')" src="/img/tico_question.png" alt="Slide Image" style="max-width: 65px;margin-left: -9px"></v-img>
                          <v-img eager  v-if="card['data']['type'].includes('dmx')" src="/img/tico_dmx.png" alt="Slide Image" style="max-width: 65px;margin-left: -9px"></v-img>

                       
                          <v-img eager  v-if="card['data']['type']=='ka_main'" src="/img/bigstar.png" alt="Slide Image" style="max-width: 65px;margin-left: -9px"></v-img>
                          <v-img eager  v-if="card['data']['type']=='sell_task'" src="/img/bigstar.png" alt="Slide Image" style="max-width: 65px;margin-left: -9px"></v-img>

                          <div>
                            <v-img eager  v-if="card['moderate']=='1'" src="/img/task_mod.png" class="task_state_img" style="margin-left: -9px"></v-img>
                            <v-img eager  v-if="card['moderate']!='1'&&card['correct']=='0'" src="/img/task_fail.png" class="task_state_img" style="margin-left: -9px"></v-img>
                            <v-img eager  v-if="card['moderate']!='1'&&card['correct']=='1'" src="/img/task_ok.png" class="task_state_img" style="margin-left: -9px"></v-img>
                          </div>

                      </div>
                      <!-- <div>
                        <v-img eager  v-if="card['moderate']=='1'" src="/img/task_mod.png" alt="Slide Image" style="max-width: 40px;"></v-img>
                        <v-img eager  v-if="card['moderate']!='1'&&card['correct']=='0'" src="/img/task_fail.png" alt="Slide Image" style="max-width: 40px;"></v-img>
                        <v-img eager  v-if="card['moderate']!='1'&&card['correct']=='1'" src="/img/task_ok.png" alt="Slide Image" style="max-width: 40px;"></v-img>
                      </div> -->


                      
                    </v-col>
                    </v-row>
                <!-- <v-img :src="item.image" alt="Slide Image"></v-img> -->
               </v-card> 
            </div>
          </div>
          <div class="controls">
            <button v-if="showNav" :class="{ disabled: atStart }" class="nav prev left-arrow" type="button" @click="prev"></button>

            <div class="dots3">
              <button
                v-for="(i, idx) in dotWindow"
                :key="i"
                type="button"
                class="custom-dot"
                :class="{
                  active: i === activeSlide,
                  edge: (idx === 0 || idx === dotWindow.length - 1) && i !== activeSlide
                }"
                @click="goTo(i)"
                aria-label="Go to slide"
              />
            </div>

            <button v-if="showNav"  :class="{ disabled: atEnd }"  class="nav next right-arrow" type="button" @click="next"></button>
          </div>
        </div>
    </v-card>
    </v-col>
  </v-row>


  <!-- 
  
  temp_publish
  -->
  <v-row id="last_act_block"   justify="center" no-gutters style="    margin-top: 30px;    margin-bottom: 15px;">
    <v-col   cols="12" >
      <v-card style="width: 100%;border-radius: 20px; /*min-height: 250px;*/padding: 10px;" class="transparent_to_background">
        <div style="padding: 15px;margin-top: -10px;margin-bottom: -20px;">
        <span  class="header_task">Останні події</span>
      </div>
        



        <v-row   justify="center"  style="    margin-left: -5px;    margin-right: -5px;    margin-top: -5px;    margin-bottom: 10px;">
    <v-col   cols="12" >
      <v-card style="width: 100%;border-radius: 20px; min-height: 40px;padding: 13px;padding-bottom: 0px;" class="transparent_to_background">
        <div>
          <v-progress-linear
            :value="progress"
            height="8"
            class="custom-progress-bar"
            style="--v-progress-linear-color: #4caf50; --v-progress-linear-background-color: #ddd"
            color="orange"
          ></v-progress-linear>
        </div>
        <div><span style="font-size: 14px;" class="header_task">Виконано завдань: <div id="tpercent" style="display:inline-block;font-size: 14px;" class="header_task"></div>%</span></div>
       
    </v-card>
    </v-col>
  </v-row>  





        
    </v-card>
    </v-col>
  </v-row>

  <!-- останни подии -->




<!-- новини -->
  <v-row justify="center" no-gutters style="    margin-top: 10px;    margin-bottom: 15px;" id="news_block">
    <v-col   cols="12" >
      <v-card style="width: 100%;border-radius: 20px; min-height: 250px;padding: 10px;" class="transparent_to_background">
        <div style="padding: 15px;margin-top: -10px;margin-bottom: 0px;">
        <span  class="header_task">Новини</span>
      </div>
        <v-card class="brand_card" style="margin-bottom: 25px;    padding: 10px;"
        elevation="10" v-for="(content, i) in news" :key="i">
        <v-row align="center"
        justify="center" @click="$router.push({ name: 'News' })">
          <v-col cols="2"><v-img src="/img/n_ico.png" class="ma-auto" style="max-width: 45px;padding-left: 5px;margin-left: 5px;" ></v-img>
          </v-col>
          <v-col cols="10">{{ content.header }}</v-col>
        </v-row>
        
      </v-card>


    </v-card>
    </v-col>
  </v-row> 


  

  <v-row id="glob_info" justify="center" no-gutters style="    margin-top: 25px;    margin-bottom: 15px;">
    <v-col   cols="12" >
      <v-card style="width: 100%;border-radius: 20px; min-height: 250px;" class="transparent_to_background">
        <div style="padding: 15px;margin-top: -10px;margin-bottom: 0px;">
        <span style="padding: 15px;margin-top: 10px;" class="header_task">Інформація</span>
        </div>



        <v-row>
          <v-col cols="12" style="display: flex;justify-content: space-around;">
            <div @click="$router.push({ name: 'C_info' })"  class="simple_card" style="    width: 48%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px;font-size: 19px;white-space: nowrap;">
              <div><img src="/img/main_ico_company.png" style="height:84px;width: auto;"> </div>
              <div>Про компанію</div>
            </div>

            <div  @click="$router.push({ name: 'News_pg' })" class="simple_card" style="    width: 40%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px;font-size: 19px">
              <div><img src="/img/main_ico_plan.png" style="height:84px;width: auto;"> </div>
              <div>Планограма</div>
            </div>

          </v-col> 
        </v-row>




        
        
          <v-row   justify="center"  style="    margin-left: -5px;    margin-right: -5px;    margin-top: 10px;    margin-bottom: 10px;">
    <v-col   cols="12" >
      <v-card style="width: 100%;border-radius: 20px; min-height: 200px;" class="transparent_to_background">
        <span style="padding: 15px;margin-top: 10px;" class="header_task">Про бренди</span>
        <div class="carousel-wrapper">
          <div class="carousel" ref="slick2">
           
            <v-card  @click=" $router.push({ name:'Info_Brands_Davidoff'})" style="width:200px;height:105px;margin: 9px;" class="carousel-item d-flex align-center justify-center simple_card">
              <v-img src="/img/ico_top/davidoff_black.png" alt="Slide Image" class="responsive-img"       max-width="170px"       max-height="100%"  style="padding-left: 15px;padding-right: 15px"    contain eager ></v-img>
            </v-card>
           <v-card  @click=" $router.push({ name:'Info_Brands_West'})" style="width:200px;height:105px;margin: 9px;" class="carousel-item d-flex align-center justify-center simple_card">
              <v-img src="/img/brand_logo_west.png" alt="Slide Image" class="responsive-img"       max-width="170px"       max-height="100%"  style="padding-left: 15px;padding-right: 15px"    contain eager ></v-img>
            </v-card>
            <!-- <v-card  @click=" $router.push({ name:'Info_Brands_PS'})" style="width:200px;height:105px;margin: 9px;" class="carousel-item d-flex align-center justify-center">
              <v-img src="/img/ico_top/ps_ico_top2.png" alt="Slide Image" class="responsive-img"       max-width="170px"       max-height="100%"  style="padding-left: 15px;padding-right: 15px"    contain eager ></v-img>
            </v-card> -->
           <v-card  @click=" $router.push({ name:'Info_Brands_Jade'})" style="width:200px;height:105px;margin: 9px;" class="carousel-item d-flex align-center justify-center simple_card">
              <v-img src="/img/ico_top/jade_ico_top_new.png" alt="Slide Image" class="responsive-img"       max-width="170px"       max-height="100%"  style="padding-left: 15px;padding-right: 15px"    contain eager ></v-img>
            </v-card>
            <v-card  @click=" $router.push({ name:'Info_Brands_ImperialClassic'})" style="width:200px;height:105px;margin: 9px;" class=" carousel-item d-flex align-center justify-center simple_card">
              <v-img src="/img/ico_top/ic_ico_top.png" alt="Slide Image" class="responsive-img"       max-width="170px"       max-height="100%"  style="padding-left: 15px;padding-right: 15px"    contain eager ></v-img>
            </v-card>
           <v-card  @click=" $router.push({ name:'Info_Brands_Prima'})" style="width:200px;height:105px;margin: 9px;" class="carousel-item d-flex align-center justify-center simple_card">
              <v-img src="/img/ico_top/prima_ico_top.png" alt="Slide Image" class="responsive-img"       max-width="170px"       max-height="100%"  style="padding-left: 15px;padding-right: 15px"    contain eager ></v-img>
            </v-card>
          </div>
        </div>
    </v-card>
    </v-col>
  </v-row>  


          <v-row style="margin-top:-15px ;">
              <v-col cols="12" style="display: flex;justify-content: space-around;">
                <div @click="$router.push({ name: 'Vazhl_sel' })"  class="simple_card" style="    width: 48%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 12px;font-size: 19px;white-space: nowrap;">
                  <div><img src="/img/main_ico_vaszhl.png" style="height:70px;width: auto;"> </div>
                  <div>Про важливе</div>
                </div>

                <div  @click="startTour" class="simple_card" style="    width: 40%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 12px;font-size: 19px">
                  <div><img src="/img/main_ico_instr.png" style="height:70px;width: auto;"> </div>
                  <div>Інструкція</div>
                </div>

              </v-col> 
            </v-row>



    </v-card>
    </v-col>
  </v-row>
  
<!-- 
temp_publish
      <v-row class="ma-1 pa-0" >
      <v-col cols="1"></v-col>
      <v-col cols="10" class="ma-1 pa-0"
        ><btnsqr        
          img="img/ico_m_exit.png" 
           @click.native="logout()"
         
          >
          Вийти
        </btnsqr></v-col><v-col cols="1"></v-col>
    </v-row> -->





<v-dialog
        v-model="dialog_netw_confirm"
         style="z-index:50000;"
      >
      <v-card class="rounded-lg" style="" elevation="10">
          <v-card-title style="background-color:orange;color:white;margin-bottom:15px;text-align:center;justify-content: center;">Мережевий iTeam</v-card-title>
          <v-card-text>
             <v-row> <v-col>
              <p><b>  Запит очікує підтвердження модератором.</b></p>
              <p>Ви зможете продовжити реєстрацію та виконувати завдання після підтвердження приєднання точки до мережі.</p>
                </v-col>
             </v-row>
          </v-card-text>
          <v-card-actions>
            
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog_netw_confirm = false"
            >
              Закрити
            </v-btn>
          </v-card-actions>
      </v-card>
</v-dialog>


<v-dialog
        v-model="dialog_task_confirm"
         style="z-index:50000;"
      >
      <v-card class="rounded-lg" style="" elevation="10">
          <v-card-title style="background-color:orange;color:white;margin-bottom:15px;text-align:center;justify-content: center;">Приєднання до iTeam</v-card-title>
          <v-card-text>
             <v-row> <v-col>
              <p><b>  Запит очікує підтвердження модератором.</b></p>
              <p>Ви зможете продовжити реєстрацію та виконувати завдання після підтвердження адміністраторами обраного типу точки.</p>
                </v-col>
             </v-row>
          </v-card-text>
          <v-card-actions>
            
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog_task_confirm = false"
            >
              Закрити
            </v-btn>
          </v-card-actions>
      </v-card>
</v-dialog>

<v-dialog
        v-model="dialog_sku_confirm"
         style="z-index:50000;"
      >
      <v-card class="rounded-lg" style="" elevation="10">
          <v-card-title style="background-color:orange;color:white;margin-bottom:15px;text-align:center;justify-content: center;">Ассортимент iTeam</v-card-title>
          <v-card-text>
             <v-row> <v-col>
              <p><b>  Запит очікує підтвердження модератором.</b></p>
              <p>Ви зможете виконувати завдання після підтвердження.</p>
                </v-col>
             </v-row>
          </v-card-text>
          <v-card-actions>
            
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog_sku_confirm = false"
            >
              Закрити
            </v-btn>
          </v-card-actions>
      </v-card>
</v-dialog>

<v-dialog
        v-model="pass_change"
        persistent
        
        width="300" 
      >

      <v-form @submit.prevent="pass_set_new"> 
      <v-card class="rounded-lg" style="" elevation="10">
          <v-card-title style="background-color:orange;color:white;margin-bottom:15px;text-align:center;justify-content: center;">Встановіть новий пароль</v-card-title>
          <v-card-text>
            <!-- <v-row fluid>
             
                <v-col cols="12">
                  <v-text-field
                    v-model="password_old"
                    name="Password1n"
                    label="Cтарий пароль"
                    solo
                    rounded
                    @click:append="show1 = !show1"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                  
                  ></v-text-field>
                </v-col>
               
              </v-row> -->
              <v-row fluid >
          <v-col cols="1"></v-col>
          <v-col cols="10">
            <center><a @click="pass_gen">Згенерувати надійний пароль</a></center>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
              <v-row fluid>
                
                <v-col cols="12">
                  <v-text-field
                    v-model="password_new"
                    name="new-password"
                    label="Новий пароль"
                    solo
                    rounded
                    @click:append="show3 = !show3"
                    :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show3 ? 'text' : 'password'"
                  ></v-text-field>
                </v-col>
                
              </v-row>
              <v-row fluid>
               
                <v-col cols="12">
                  <v-text-field
                    v-model="password_new_confirm"
                    name="confirm-new-password"
                    label="Підтвердження паролю"
                    solo
                    rounded
                    @click:append="show2 = !show2"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show2 ? 'text' : 'password'"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-col>
               
              </v-row>
           
            
          </v-card-text>
          <v-card-actions>
            
            <v-btn
              color="primary"
              text
              type="submit"
            >
              Встановити
            </v-btn>
            <!-- <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="pass_change = false"
            >
              Відмінити
            </v-btn> -->
          </v-card-actions>
      </v-card>
      </v-form>
</v-dialog>

<v-dialog
z-index="50000"
        v-model="cd_enter"
        persistent
        width="300" style="z-index:50000;"
      >
      <v-card class="rounded-lg" style="" elevation="10">
          <v-card-title style="background-color:orange;color:white;margin-bottom:15px;text-align:center;justify-content: center;">Вкажіть точку</v-card-title>
          <v-card-text>
             <v-row fluid>
                <v-col cols="1"></v-col>
                <v-col cols="10">
                  <v-text-field
            
                    v-model="pos_code"
                    name="pos_code"
                    label="С-"
                    solo
                    rounded
                    v-maska="'C-########'" 
                    inputmode="numeric"
                  ></v-text-field>
                </v-col>
               
              </v-row>
              <v-row>
                  <v-col cols="1"></v-col>
          <v-col cols="10">
            <v-radio-group v-model="tt_type">
              <v-radio label="Неконтрактна звичайна" value="no_contract_usual"></v-radio>
              <v-radio label="Неконтрактна мережева" value="no_contract_network"></v-radio>
              <v-radio label="TIP" value="tip"></v-radio>
              <v-radio label="KA" value="ka"></v-radio>
            </v-radio-group>
            <!-- <v-checkbox v-model="checkbox_is_network" color="#ee6424" class="ma-0 pa-0">
              <template v-slot:label>
                <div>
                  Позначте, якщо ваша ТТ мережева.
                </div>
              </template>
            </v-checkbox> -->
          </v-col>
          
        </v-row>
           
            
          </v-card-text>
          <v-card-actions>
            
            <v-btn
              color="primary"
              text
              @click="cd_set"
            >
              Зберегти
            </v-btn>
            <!-- <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="pass_change = false"
            >
              Відмінити
            </v-btn> -->
          </v-card-actions>
          <confirmdlg ref="confirm" />
      </v-card>
</v-dialog>
<!-- new_task_requirements_block_start -->
<v-dialog v-model="write_tp">
      <v-card>
        <v-card-title   style="background-color:orange;color:white;z-index:1;margin-bottom:20px;justify-content:center;text-align:center;">
          <!-- header -->
          {{$t('h_contact')}}  
        </v-card-title>
       
        <v-card-text>
          <v-row   justify="center">
         <v-col cols="10" sm="4" md="4">
           <span v-html='tt_lock_reason'></span>
            </v-col>
          </v-row>
          <v-row   justify="center">
         <v-col cols="10" sm="4" md="4">
             <v-textarea
            outlined
            name="input-7-4"
            label=""
            value=""
            v-model=req_tp_tp
          ></v-textarea>

          <v-btn primary large block type="submit" @click="save_request_unlock_tt"  class="primary_button">Надіслати</v-btn>
         </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <span class="link" text @click="write_tp = false">   {{$t('close')}} </span>
        </v-card-actions>
      </v-card>
    </v-dialog>



<v-dialog v-model="new_type_task_info">
      <v-card>
        <v-card-title   style="background-color:orange;color:white;z-index:1;margin-bottom:20px;justify-content:center;text-align:center;">
          <!-- header -->
          Увага!  
        </v-card-title>
       
        <v-card-text>
          <v-row   justify="center">
         <v-col cols="10" sm="4" md="4">
           <span >Дорогі партнери!<br>
На період військового стану вам буде надаватися можливість вибору рівня складності обов'язкових завдань. Кількість балів, що нараховується, залежить від обраного рівня. Обирати новий рівень складності можна кожні 2 тижні, а тип контракту при цьому залишається незмінним.
</span>
            </v-col>
          </v-row>
        
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <span class="link" text @click="new_type_task_info = false;$router.push({name:'Tasks'})">  До завдань </span>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="da_banner">
      <v-card>
        
       
        
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <span class="link" text @click="da_banner= false;">Закрити</span>
        </v-card-actions>
        <v-card-text style="padding:0 !important">
          <v-row   justify="center">
         <v-col cols="12" >
         <v-img src="img/db.png" ></v-img>
            </v-col>
          </v-row>
        
        </v-card-text>
      </v-card>
    </v-dialog>
<!-- new_task_requirements_block_end -->
  <InstructionTour      :tourActive="tourActive"      :steps="tourSteps"    @updateTourActive="tourActive = false"></InstructionTour>
</v-container>
</template>



<script>
import axios from "axios";
import { API_LOCATION } from "../../config";
import confirmdlg from "../components/confirmdlg.vue";
import btnsqr from "../components/btnsqr.vue";
//import l_switch from "../components/lang_switch.vue";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import $ from 'jquery';
import 'slick-carousel';
import InstructionTour from '../components/InstructionTour.vue';
export default {
  watch:{
    

    

  },
  // eslint-disable-next-line vue/no-unused-components
  components:{confirmdlg: confirmdlg,btnsqr, InstructionTour},
  computed: {
     atStart() {
      return this.activeSlide <= 0;
    },
    atEnd() {
      return this.activeSlide >= this.slideCount - 1;
    },
    points: function () {
      return this.$store.getters.points;
    },
    progress:function(){
      $('#tpercent').html(Math.round(this.task_executed/this.task_total*100));
      return this.task_executed/this.task_total*100;
    }
  },
  data: () => ({
    tourActive: false,
      tourSteps: [
        { selector: '#header', header:'Погляньмо наверх!',description: 'Завдяки <div class="i_uico"></div> ти можеш потрапити у свій профіль!' },
        { selector: '#header', header:'Погляньмо наверх!',description: 'Натиснувши на <div class="i_mico"></div> , ти побачиш архів сповіщень' },
        { selector: '#header', header:'Погляньмо наверх!',description: 'Якщо тобі потрібна допомога, зв’яжись з технічною підтримкою завдяки  <div class="i_tp"></div> ' },
        { selector: '#containeri1', header:'Йдемо далі!',description: 'Твої поточні бали, щоб не загубити!' },
        { selector: '#task_block', header:'Твої завдання!',description: 'Зверни увагу, що ти можеш прогорнути перелік завдань вправо. ' },
        { selector: '#last_act_block', header:'Завжди в курсі подій!',description: 'Завдяки стрічці подій, ти бачитимеш статус завдань, вихід новин та нарахувань! А також зможеш відлсідкувати кількість виконаних завдань!' },
        { selector: '#news_block',  header:'Завжди в курсі подій!',description: 'Тепер новини стали доступніші!' },
        { selector: '#glob_info',  header:'Завжди в курсі подій!',description: 'Дізнавайся більше про компанію ІТЮ та портфель брендів, поточні планограми та соціально-важливі новини!' },
        { selector: '#footer',  header:'Зручна навігація',description: 'Хочеш переглянути історію нарухвань? Перейди у розділ “Мої бали”.<br><br>Якщо вже заробив достатньо для використання, відкривай “Сертифікати”' },
      
      ],
    tt_type:'',
    da_banner:false,
    dialog_netw_confirm:false,
    dialog_task_confirm:false,
    dialog_sku_confirm:false,
    sku_lock:false,
    cd_enter:false,
    cd_lock:false,
    pass_lock:false,
    pos_code:'C-',
    network_lock:false,
    task_lock:false,
    deleted_lock:false,
    task_pending:0,
    menu_active:true,
    pass_change:false,
    password_old:null,
    password_new:null,
    password_new_confirm:null,
    show1: false,
    show2: false,
    show3: false,
     g:{long:'',lat:'',coord_state:''},
    write_tp:false,
    req_tp_tp:'',
    tt_lock_reason:'',
    new_type_task_info:false,
    ignore_err:false,
    initialArrowSetting: false,
    news:[],
    task_total:0,
    task_executed:0,
    items : [  { image: '/img/tzap.png' }, 
    { image: '/img/tzap.png' },  { image: '/img/tzap.png' }, 
    { image: '/img/tzap.png' },  { image: '/img/tzap.png' }, 
    ],
    cards: [],
    brands:[
      {name:'davidoff',img:'davidoff_black.png',link:'Info_Brands_Davidoff'},
      {name:'davidoff',img:'west_ico_top.png',link:'Info_Brands_West'},
      {name:'davidoff',img:'ps_ico_top2.png',link:'Info_Brands_PS'},
      {name:'davidoff',img:'jade_ico_top_new.png',link:'Info_Brands_Jade'},
      {name:'davidoff',img:'ic_ico_top.png',link:'Info_Brands_ImperialClassic'},
      {name:'davidoff',img:'prima_ico_top.png',link:'Info_Brands_Prima'},


    ],
    links: {
      sku_photo: "Phototask",
      lay_photo: "Phototask",
      mlevel_sku_photo: "Phototask",
      mlevel_sku_photo_dmx: "Phototask_dmx",
      mlevel_sku_photo_dmx_multi: "Phototask_dmx",
      mlevel_lay_photo: "Phototask",
      
      ex_photo: "Phototask",
      ex_photo_code: "Phototask",
      ex_photo_timer: "Phototask",
      ex_photo_dmx: "Phototask_dmx",
      ex_photo_dmx_multi: "Phototask_dmx",
      custom_extra_photo: "Phototask",
      test: "Testtask",

      ka_main:"Ka_main",

      
      sell_task:"Sell_task",

    },
    showNav: false,
    dotWindow: [],        // array of slide indexes to show (len 1..3)
    activeSlide: 0,
    slideCount: 0,
    
  }), 
  methods: {
     rebuildWindow(windowSize = 3) {
        const count = this.slideCount;
        if (!count) {
          this.dotWindow = [];
          return;
        }

        // clamp windowSize
        windowSize = Math.max(1, Math.min(windowSize, count));

        // try to keep active centered in the window
        const half = Math.floor(windowSize / 2);

        let start = this.activeSlide - half;

        // clamp start into valid range [0 .. count-windowSize]
        if (start < 0) start = 0;
        const maxStart = count - windowSize;
        if (start > maxStart) start = maxStart;

        this.dotWindow = Array.from({ length: windowSize }, (_, k) => start + k);
      },
    goTo(i) {
      const $slick = $(this.$refs.slick);
      if ($slick.hasClass("slick-initialized")) $slick.slick("slickGoTo", i);
    },
    prev() { $(this.$refs.slick).slick("slickPrev"); },
    next() { $(this.$refs.slick).slick("slickNext"); },
    startTour() {
      
      this.tourActive = true;
      
    },
    pass_gen: function(){
      var chars = "0123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKMNPQRSTUVWXYZ";
      var passwordLength = 8;
      var password = "";
      for (var i = 0; i <= passwordLength; i++) {
        var randomNumber = Math.floor(Math.random() * chars.length);
        password += chars.substring(randomNumber, randomNumber +1);
      }
      if(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/.test(password)==false) { this.pass_gen(); }
      else {
        this.password_new=password
        this.password_new_confirm=password
        this.show1=true
        this.show2=true
        this.show3=true
        console.log(password)
        }
    },
    save_request_unlock_tt: function(){

            axios.post(API_LOCATION,  { data: 'component_data',action: 'save_request_unlock_tt', 'question':this.req_tp_tp },{ headers: { 'content-type': 'application/x-www-form-urlencoded' } })
         .then(resp =>{
           
         if(resp.data=='OK'){ 
            //this.$store.commit('setSnack', 'Запит надіслано!')
            
            this.$emit('pushe', {header:'Повідомлення',text:'Запит надіслано!'});
            this.write_tp=false;
            this.req_tp_tp='';
            //this.$router.push({ name: 'Profile'})
          }
          })
            
        },
    navOnSuccess(position) {
                 console.log('Latitude: '          + position.coords.latitude          + '\n' +
                        'Longitude: '         + position.coords.longitude         + '\n' +
                        'Altitude: '          + position.coords.altitude          + '\n' +
                        'Accuracy: '          + position.coords.accuracy          + '\n' +
                        'Altitude Accuracy: ' + position.coords.altitudeAccuracy  + '\n' +
                        'Heading: '           + position.coords.heading           + '\n' +
                        'Speed: '             + position.coords.speed             + '\n' +
                        'Timestamp: '         + position.timestamp                + '\n');
                        
                        
                        this.g.long = position.coords.longitude
                        this.g.lat = position.coords.latitude
                        this.g.coord_state='success'
                        console.log('long: '+this.g.long+': lat:'+this.g.lat)
                        //alert('long: '+this.g.long+': lat:'+this.g.lat)
                        console.log(this.g);

              },

              navOnError(error) {
                  console.log('NAV_FAIL: code: '    + error.code    + '\n' +
                        'message: ' + error.message + '\n')
              },
    logout: function () {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },

    task_go:function(){
    
            axios
      .post(
        API_LOCATION,
        {
          
          action: "task_go"
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
      
        console.log(resp.data);
        if(resp.data.state=='tt_check_messsage'){
            if(resp.data.type==1){
              this.tt_lock_reason='За нашими даними, ваша торгова точка знаходиться на тимчасово окупованій території. Доступ до розділу «Завдання», на жаль, для вас тимчасово обмежений. Але ми дуже чекаємо на ваше повернення до програми!<br>Повідомте нас, будь ласка, якщо у вас збереглася можливість подальшої співпраці.'
              this.write_tp=true;
              return;
            }
            if(resp.data.type==3){
              this.tt_lock_reason='Ваша торгова точка знаходиться в списку точок, які тимчасово не можуть брати участь у програмі у зв’язку зі складною ситуацією в регіоні. Але ми дуже чекаємо на ваше повернення до програми!<br>Повідомте нас, будь ласка, якщо у вас збереглася можливість подальшої співпраці.'
              this.write_tp=true;
              return;
            }
            if(resp.data.type==9||resp.data.type==10){
              this.$emit('pushe', {header:'Повідомлення',text:'Ваш запит відправлено на опрацювання. При розблокуванні торгової точки, надійде відповідне інформаційне sms-повідомлення.'});
              return;
            }
        }
        /*
        else if(resp.data.state=='temp_task')
        {
          this.$router.push("/asssel_temp");
        }
        else if(resp.data.state=='new_type_task_info')
        {
          this.new_type_task_info=true;
        }*/
        else if(resp.data.state=='go')
        {
               
           this.$router.push("/Tasks");    
        }

      });


    
  },

    da_bannerc:function(){
    
            axios
      .post(
        API_LOCATION,
        {
          
          action: "da_banner"
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
      
        if(resp.data.state=='da_banner'){
          this.da_banner=true;
        }
        

      });


    
  },

    pass_set_new:function(){
      
        this.show2=false
            axios
      .post(
        API_LOCATION,
        {
          
          action: "pass_set_new",
          pass_old:this.password_old,
          pass_new1: this.password_new,
          pass_new2: this.password_new_confirm,
          temp:true
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
      
        console.log(resp.data);
        if(resp.data.pass_set!='ok'&&resp.data.debug!='on')
        {
          alert(this.$t(resp.data.error));
        }
        else
        {
          alert(this.$t('success_change'));
          this.pass_change=false;
          this.logout();

        }
      });


    
  },
  
  
  
  
  cd_set: async function(){
        await    axios
      .post(
        API_LOCATION,
        {
          
          action: "cd_update",
          pos_code: this.pos_code,
          tt_type: this.tt_type,
          
          ignore_err:this.ignore_err
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then(async (resp) => {



        console.log(resp.data);
        if(!this.ignore_err&&resp.data.reg_final!='ok'&&resp.data.debug!='on'&&resp.data.error!='no tip'&&resp.data.error!='no iteam'&&resp.data.error!='no ka')
        {         
          alert(this.$t(resp.data.error));
        } 
        else
        {
          console.log('in first else (almoust done)');

          if(!this.ignore_err&&(resp.data.error=='no tip'||resp.data.error=='no iteam'||resp.data.error=='no ka')){
            console.log('in second else (call confirm)');


            if (        await this.$refs.confirm.open("Підтвердження", this.$t(resp.data.error)))
              { 
                this.ignore_err=true
                this.cd_set()
              

          } else { console.log('canceled')}

          


          }
          else{
            this.cd_enter=false;
                this.cd_lock=false;
                if(!this.cd_lock&&!this.pass_lock) { this.menu_active=true;}
          }



        }








      
        // console.log(resp.data);
        // if(resp.data.reg_final!='ok'&&resp.data.debug!='on')
        // {
        //   alert(this.$t(resp.data.error)+'\n'+resp.data.tt_data);
        // }
        // else
        // {
               
        //         this.cd_enter=false;
        //         this.cd_lock=false;
        //         if(!this.cd_lock&&!this.pass_lock) { this.menu_active=true;}
        // }
      });


    
  },
   get_cd_exist: function(){
      axios
      .post(
        API_LOCATION,
        {
          
          action: "is_cd_exist"
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
            console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!CD'+resp.data);
              if(resp.data==false)         {
                this.menu_active=false;
                this.cd_enter=true;
                this.cd_lock=true;
              } 
              
        
      });

    },
    get_temp: function(){
      axios
      .post(
        API_LOCATION,
        {
          
          action: "is_temp_pass"
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
              if(resp.data==1)         {
                this.menu_active=false;
                this.pass_change=true;
                this.pass_lock=true;
              } 
              
        
      });

    },
    get_k_type: function(){
      axios
      .post(
        API_LOCATION,
        {
          
          action: "k_type"
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
              if(resp.data==9)         {
                this.$router.push("/Asssel");
              } 
              else if(resp.data==10)     {
                 this.$router.push("/Asssel");
              }
        
      });

    },
    get_pending_task: function(){
      axios
      .post(
        API_LOCATION,
        {
          
          action: "pending_task"
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
              this.task_pending=resp.data;
              console.log('PENDING:'+resp.data);
              
        
      });

    },
    get_pending_network_confirm: function(){
      axios
      .post(
        API_LOCATION,
        {
          
          action: "is_network_pending"
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
              if(resp.data==1)         {
                this.dialog_netw_confirm=true;
                this.network_lock=true
              }
        
      });

    },
    get_pending_task_confirm: function(){
      axios
      .post(
        API_LOCATION,
        {
          
          action: "is_task_pending"
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
              if(resp.data==1)         {
                this.dialog_task_confirm=true;
                this.network_lock=true
              }
        
      });

    },
    get_pending_sku_confirm: function(){
      axios
      .post(
        API_LOCATION,
        {
          
          action: "is_sku_pending"
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
              if(resp.data==1)         {
                this.dialog_sku_confirm=true;
                this.sku_lock=true;
              }
        
      });

    },
    get_pending_profile: function(){
      axios
      .post(
        API_LOCATION,
        {
          
          action: "get_pending_profile"
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
            if(resp.data==0)
            {
            this.$router.push("/Profile");
            }
            console.log('PROFILE',resp.data)
        
      });

    },
    get_pending_sku_change: function(){

      axios
      .post(
        API_LOCATION,
        {
          
          action: "sku_change"
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
            if(resp.data==1)
            {
            this.$router.push({
                     name: 'Asssel',
                     params: { change_type: 1 },
                     })
            }
           
        
      });

    },
    get_pending_reg_complete: function(){

    },

    initializeSlick() {

 const $slick = $(this.$refs.slick);

    // If re-initializing after new ajax data
    $slick
  .on("init.custom", (e, slick) => {
    this.slideCount = slick.slideCount;
    this.activeSlide = slick.currentSlide || 0;
    this.showNav = slick.slideCount > 5;
    this.rebuildWindow(5);
  })
  .on("afterChange.custom", (e, slick, current) => {
    this.activeSlide = current;
    this.rebuildWindow(5);
  });


      this.$nextTick(() => {
        $(this.$refs.slick).slick({
            dots: false,
            arrows: this.initialArrowSetting,  // Disable arrow controls
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            //centerMode: true,  // Show part of the next slide
            variableWidth: true, // Allow cards of different widths to appear properly
          
            // eslint-disable-next-line no-unused-vars
            customPaging: function(slider, i) {
              return '<div class="custom-dot"></div>';
            }
          });

         // this.setupSlickControls();
      })
      
    },
    setupSlickControls() {
      // Run after Slick has initialized to modify options if needed
      $(this.$refs.slick).on('afterChange', (event, slick, currentSlide) => {
        // Enable arrows if there are more than three slides
        if (slick.slideCount > 4 && !slick.options.arrows) {
          $(this.$refs.slick).slick('slickSetOption', 'arrows', true, false);
        }

        // Adjust visible dots around the current slide
        let startDot = Math.max(0, currentSlide - 1);
        let endDot = startDot + 4;

        $('.slick-dots li').hide().slice(startDot, endDot).show();
      });

      // Manually trigger the first `afterChange` to set the initial state
      $(this.$refs.slick).slick('slickGoTo', 0);
    },
    
    initializeSlick2() {
      this.$nextTick(() => {
        $(this.$refs.slick2).slick({
                dots: true,
                arrows: false,  // Disable arrow controls
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                //centerMode: true,  // Show part of the next slide
                variableWidth: true, // Allow cards of different widths to appear properly
              
                // eslint-disable-next-line no-unused-vars
                customPaging: function(slider, i) {
                  return '<div class="custom-dot custom-dot2"></div>';
                }
              });



      });
    }


    
  },
  mounted() {
    axios
        .post(
          API_LOCATION,
          { data: "component_data", action: "get_news_latest", id: this.task_id },
          { headers: { "content-type": "application/x-www-form-urlencoded" } }
        )
        .then((resp) => {
          
          this.news=resp.data;
          console.log('!!!news');
          console.log(this.news);
        });
    //task_slider_start

    

    //task_slider_end

    axios
      .post(
        API_LOCATION,
        {
          data: "component_data",
          action: "get_tasks",
          filter: this.$route.params.routeparam,
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
        // eslint-disable-next-line no-unused-vars
       
        (resp.data ?? []).forEach((element) => {
         
          

          this.cards.push({
            id: element.id,
            type: element.type,
            start_date: element.start_date,
            end_date: element.end_date,
            data: JSON.parse(element.data_json),
            ex: element.id_ex,
            id_ex_previous: element.id_ex_previous,
            correct: element.correct,
            moderate: element.moderate,
            
          });
          this.task_total++;
          if(element.id_ex&&element.moderate!=1&&element.correct!=0){ this.task_executed++ }

          console.log(element.moderate!='1'&&element.correct=='1');
        });
        this.overlay_main = false;
        console.log(resp.data);
        //console.log(this.cards);
        this.initializeSlick();
        this.initializeSlick2();
        console.log(this.task_total+'^'+this.task_executed);
      });

  },
  created() {

    this.get_cd_exist();
    this.get_temp();
    this.get_pending_task();
    this.get_pending_profile();
    this.get_pending_sku_change();
    this.da_bannerc();
          if (navigator.geolocation)
              {
              navigator.geolocation.getCurrentPosition(this.navOnSuccess, this.navOnError,{enableHighAccuracy:false,maximumAge:Infinity, timeout:60000})
               console.log('start_nav_detect')
              }
              else
              {
                console.log('geolocation_not_supported')
              }

    this.$store.dispatch("profileset");
    
    this.$store.dispatch("page_title_set", "Головна");  
    
    axios
      .post(
        API_LOCATION,
        {
          
          action: "api_check"
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
              console.log(resp.data);         
        
      });
    this.get_k_type();
    this.get_pending_sku_confirm();
    this.get_pending_network_confirm();
    this.get_pending_task_confirm();


      console.log(this.brands);






  },
};
</script>


<i18n>
{
  "ua": {
    "h_contact":"Доступ обмежено",
    "wrong_old":"Помилковий старий пароль",
"pass not match":"Паролі не співпадають",
"pass insecure":"Пароль має містити від 8 символів, серед яких має бути мінімум 1 цифра, 1 велика літера, 1 маленька літера.",
    "success_change":"Пароль успішно змінено, увійдіть до додатку з новим паролем",
"close":"Закрити",
 "check_pos":"Вказана точка відсутня в базі",
 "no type":"Оберіть тип торгової точки, щоб продовжити реєстрацію",
 "no ka":"У базі відсутня відмітка \"KA\" для вказаної точки. Користувач зможе продовжити реєстрацію лише після погодження Адміна. ",
 "no tip":"У базі відсутня відмітка \"TIP\" для вказаної точки. Користувач зможе продовжити реєстрацію лише після погодження Адміна.",
 "no iteam":"У базі торгова точка має статус контрактної. Користувач зможе продовжити реєстрацію лише після погодження Адміна. ",

 "check_pos 2 users exist":"На торговій точці вже зареєстрована максимальна кількість продавців."

  }
}
</i18n>

<style >
.carousel-item {
  padding: 0 10px;
  width: 300px; /* Ensure each card has a fixed width */
}

.slick-dots {
  bottom: -10px; /* Adjust the position of dots */
}

.custom-dot2 {
  bottom: -5px; /* Adjust the position of dots */
}

.slick-dots li button {
  display: none; /* Hide the default buttons inside the dots */
}

.slick-dots li {
  margin: 0 5px;
}

.slick-dots li::before {
  content: '';
}

.custom-dot {
  width: 12px;
  height: 12px;
  background-color: #F7B97F; /* Custom orange dots */
  border-radius: 50%;
  cursor: pointer;
  /*transition:all .25s ease;*/
}

.slick-dots .slick-active .custom-dot.active {
  background-color: darkorange; /* Active dot styling */
}
.responsive-img {
  object-fit: contain; /* Ensures the whole image is visible */
}
.slick-slide{
  margin-right: 9px;
}

.custom-progress-bar {
  --v-progress-linear-color: #F07300 !important; /* Custom fill color */
  --v-progress-linear-background-color: #5D4F46 !important; /* Custom track color */
}

.slick-dots li.dot-hidden {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}

.slick-dots {
  display: flex !important;
  justify-content: center;
  flex-wrap: nowrap !important;
  white-space: nowrap;
}

.controls{
  display:flex;
  align-items:center;
  justify-content:center;
  gap:12px;
  margin-top: 8px;
}
.dots3{
  display:flex;
  align-items:center;
  justify-content:center;
  gap:8px;
  flex:0 0 auto;
  white-space:nowrap;
  padding-bottom: 2.5px;
}
.dots3 .dot{
  width:10px; height:10px; border-radius:50%;
  border:0;
  opacity:.4;
}
.dots3 .custom-dot.active{ opacity:1; background-color: darkorange; transform:scale(1.1);}

.dots3 .custom-dot.edge{
  transform:scale(.6);
  opacity:.9;
}
.left-arrow{
  background-image: url("/img/left_arrow2x.png");
  background-size: 100%;
  width: 15px;
  height: 16px;
}
.right-arrow{
  background-image: url("/img/right_arrow2x.png");
  background-size: 100%;
  width: 15px;
  height: 16px;
}

.nav.disabled{
  opacity:0;
  pointer-events:none;
}
</style>